/* eslint-disable operator-linebreak */
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useMediaQuery, useTheme } from '@material-ui/core';
import DashboardCard from 'ui/DashboardCard/DashboardCard';
import NavigationTitle, { LayoutType } from 'ui/NavigationTitle/NavigationTitle';
import routePaths from 'routes/routePaths';
import Tabs from 'ui/Tabs/Tabs';
import { StatusModal, WarningModal } from 'components/modals';
import api from 'api/api';
import Loader from 'ui/Loader/Loader';
import Table from 'ui/Table/Table';
import { AxiosStatus } from 'api/axiosConfig';
import { IApiResponse } from 'utils/models';
import allColumns from './columns';
import { IApiScheduleTransfer, IScheduleTransfer, TabsType, TransferType } from './ScheduledTransfers.model';
import EditScheduleTransfer from './EditScheduleTransfer';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './ScheduledTransfers.module.css';
import noTransaction from 'assets/icons/noScheduleTransaction.svg';

export const tabsOptions = [
  { label: 'Between Own Accounts' },
  { label: 'To First Atlantic Bank' },
  { label: 'To Another Bank' },
  { label: 'Bulk Transfer' },
];

// const tableData = [
//   {
//     scheduleId: 'OTPSCD000038314',
//     sourceAccount: '234567891011',
//     accountType: 'Savings account',
//     beneficiaryName: 'Ann Olashile',
//     beneficiaryAccount: '234567891011',
//     beneficiaryBank: 'Brand new Bank',
//     amount: 'GHS 1,836.00',
//     totalAmount: 'GHS 1,836.00',
//     narration: 'Domestic',
//     totalBeneficiaries: '50',
//     charges: 'GHS 186.00',
//     frequency: 'Special Date',
//     specialDate: '01-02-23 02:00:00',
//     transferType: 'Instant',
//     initiator: 'Tester1',
//     approver: 'Tester2',
//     dateInitiated: '01-02-23 02:00:00',
//     dateApproved: '01-02-23 02:00:00',
//     edit: '',
//     delete: '',
//   },
//   {
//     scheduleId: 'OTPSCD000038314',
//     sourceAccount: '234567891011',
//     accountType: 'Savings account',
//     beneficiaryName: 'Ann Olashile',
//     beneficiaryAccount: '234567891011',
//     beneficiaryBank: 'Brand new Bank',
//     amount: 'GHS 1,836.00',
//     totalAmount: 'GHS 1,836.00',
//     totalBeneficiaries: '50',
//     charges: 'GHS 186.00',
//     narration: 'Domestic',
//     frequency: 'Special Date',
//     specialDate: '01-02-23 02:00:00',
//     transferType: 'Instant',
//     initiator: 'Tester1',
//     approver: 'Tester2',
//     dateInitiated: '01-02-23 02:00:00',
//     dateApproved: '01-02-23 02:00:00',
//     edit: '',
//     delete: '',
//   },
// ];

enum States {
  table = 'Table',
  edit = 'Edit',
}

const ScheduledTransfers = () => {
  const [state, setState] = useState<States>(States.table);
  const [submitStatus, setSubmitStatus] = useState<AxiosStatus>(AxiosStatus.DEFAULT);
  const [activeTab, setActiveTab] = useState<TabsType>(0);
  const [nextTab, setNextTab] = useState<TabsType>(0);
  const [showWarning, setShowWarning] = useState(false);
  const [showDeleteWarning, setShowDeleteWarning] = useState<boolean>(false);
  const [selectedScheduleId, setSelectedScheduleId] = useState<string>('');
  const [errorMsg, setErrorMsg] = useState<string>('');
  const [successMsg, setSuccessMsg] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState<any>([]);
  const [selectedData, setSelectedData] = useState<IScheduleTransfer>();
  const [transType, setTransType] = useState<TransferType>(TransferType.OWN_TRANSFER);
  const showStatusModal = submitStatus === AxiosStatus.SUCCESS || submitStatus === AxiosStatus.FAILURE;

  const downMdScreen = useMediaQuery(useTheme().breakpoints.down('sm'));

  const history = useHistory();
  const handleOnSuccess = () => {
    history.push(routePaths.dashboard);
  };

  const handleOnChangeTab = (_event: React.ChangeEvent<unknown>, tabIndex: TabsType) => {
    setNextTab(tabIndex);
    setActiveTab(tabIndex);
    switch (tabIndex) {
      case 1:
        setTransType(TransferType.LOCAL_TRANSFER);
        break;
      case 2:
        setTransType(TransferType.OTHERBANK_TRANSFER);
        break;
      case 3:
        setTransType(TransferType.BULK_TRANSFER);
        break;
      default:
        setTransType(TransferType.OWN_TRANSFER);
        break;
    }
  };

  const handleClickBack = () => {
    setShowWarning(true);
    setActiveTab(false);
  };

  const onLeavePage = () => {
    setShowWarning(false);
    if (downMdScreen) {
      setActiveTab(false);
    } else {
      setActiveTab(nextTab);
    }
  };

  const closeWarning = () => {
    setShowWarning(false);
    setShowDeleteWarning(false);
  };

  useEffect(() => {
    setSubmitStatus(AxiosStatus.PENDING);
    api
      .post('transfer/schedulePaymentTransactionList', { transType })
      .then((data: IApiScheduleTransfer) => {
        console.log(data, transType);

        setTableData(data.transactions);
      })
      .catch((error: IApiResponse) => {
        console.error(error);
        // setSubmitStatus(AxiosStatus.FAILURE);
      });
    // Promise.all([tableDataList()]).finally(() => {
    //   // setLoadingData(false);
    // });
  }, [transType]);

  const getSelectedColumn = () => {
    const { defaultColumns } = allColumns;
    if (activeTab === 2) {
      return defaultColumns.filter(
        (item) =>
          item?.accessor !== 'amount' && item?.accessor !== 'totalBeneficiaries' && item?.accessor !== 'charges',
      );
    }

    if (activeTab === 3) {
      return defaultColumns.filter(
        (item) =>
          item?.accessor !== 'beneficiaryBank' && item?.accessor !== 'transferType' && item?.accessor !== 'narration',
      );
    }

    return defaultColumns.filter(
      (item) =>
        item?.accessor !== 'beneficiaryBank' &&
        item?.accessor !== 'transferType' &&
        item?.accessor !== 'totalBeneficiaries' &&
        item?.accessor !== 'charges' &&
        item?.accessor !== 'totalAmount',
    );
  };

  const handleDeleteScheduleTransfer = () => {
    console.log('me', selectedScheduleId);
    setSubmitStatus(AxiosStatus.FAILURE);
    setErrorMsg('Schedule Transfer has been deleted!');
    setSubmitStatus(AxiosStatus.SUCCESS);
    setSuccessMsg('Schedule Transfer has been deleted!');
  };

  const handleCellClick = (cell: { row: { original: IScheduleTransfer }; column: { Header: string } }) => {
    if (cell?.column.Header === 'Edit') {
      setSelectedData(cell?.row.original);
      setState(States.edit);
    }

    if (cell?.column.Header === 'Delete') {
      setSelectedScheduleId(cell?.row.original.scheduleId);
      setShowDeleteWarning(true);
    }
  };

  const onCloseStatusModal = () => {
    if (submitStatus === AxiosStatus.SUCCESS) {
      handleOnSuccess();
    }
    setSubmitStatus(AxiosStatus.DEFAULT);
  };

  const renderEmptyTable = () => (
    <div className={styles.container}>
      <div className={styles.contentWrapper}>
        <div className={styles.imgWrapper}>
          <img src={noTransaction} alt="No data icon" />
        </div>
        <h2 className={styles.title}>No schedule transfers yet</h2>
        <div className={styles.subTitle}>Once you create any,n it appears here.</div>
      </div>
    </div>
  );

  const renderPreviewList = () => {
    if (loading) {
      setLoading(false);
      return (
        <div className={styles.m25}>
          <Loader />
        </div>
      );
    }
    return (
      <div className={styles.preview}>
        {tableData && tableData.length > 0 ? (
          <Table columns={getSelectedColumn()} data={tableData} getCellValue={handleCellClick} />
        ) : (
          renderEmptyTable()
        )}
      </div>
    );
  };

  const closeEditView = () => setState(States.table);

  return (
    <DashboardCard fullHeight>
      <NavigationTitle
        to="/scheduleTransfers"
        layoutType={LayoutType.dashboard}
        onClick={handleClickBack}
        noArrow={activeTab === false}
      >
        {activeTab === false || !downMdScreen ? 'Schedule Transfers' : tabsOptions[activeTab].label}
      </NavigationTitle>
      <Tabs value={activeTab} options={tabsOptions} onChange={handleOnChangeTab} />
      {state === States.edit ? (
        <EditScheduleTransfer onClose={closeEditView} activeTab={activeTab} selectedData={selectedData} />
      ) : (
        renderPreviewList()
      )}
      <WarningModal open={showWarning} submitName="Leave Page" onSubmit={onLeavePage} onClose={closeWarning}>
        Entered data will be lost. Are you sure you want to leave page?
      </WarningModal>
      <WarningModal
        open={showDeleteWarning}
        submitName="Delete"
        onSubmit={handleDeleteScheduleTransfer}
        onClose={closeWarning}
      >
        Are you sure you want to delete the schedule transfer?
      </WarningModal>
      <StatusModal
        open={showStatusModal}
        status={submitStatus === AxiosStatus.SUCCESS ? 'success' : 'failure'}
        onClose={onCloseStatusModal}
        // onRetry={onCloseStatusModal}
        onRetryText="Close"
      >
        {submitStatus === AxiosStatus.SUCCESS ? successMsg : errorMsg}
      </StatusModal>
    </DashboardCard>
  );
};

export default ScheduledTransfers;
